
import { useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import HeroSection from './components/HeroSection';
import ServicesGrid from './components/ServicesGrid';
import BudgetHotels from './components/BudgetHotels';
import AirportTransfers from './components/AirportTransfers';
import BusinessServices from './components/BusinessServices';
import WhyChooseUs from './components/WhyChooseUs';
import CTASection from './components/CTASection';

export default function VisitLondonPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://www.alwaz.travel';
    const scripts: HTMLScriptElement[] = [];

    const schemas = [
      {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: 'Visit London Services | Hotels, Airport Transfers & Business Travel | Alwaz Travels',
        description: 'Planning to visit London? Alwaz Travels offers budget hotels, airport transfers, business travel services, and Muslim-friendly accommodation in London for international visitors.',
        url: `${siteUrl}/visit-london`,
        isPartOf: { '@type': 'WebSite', name: 'Alwaz Travels', url: siteUrl },
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: siteUrl },
            { '@type': 'ListItem', position: 2, name: 'Visit London', item: `${siteUrl}/visit-london` },
          ],
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'Service',
        name: 'Visit London Travel Services',
        provider: {
          '@type': 'TravelAgency',
          name: 'Alwaz Travels',
          url: siteUrl,
          telephone: '+442034884455',
          address: { '@type': 'PostalAddress', addressLocality: 'London', addressCountry: 'GB' },
        },
        description: 'Comprehensive London visit services for international travellers including budget hotels, Heathrow and Gatwick airport transfers, business travel support, and Muslim-friendly accommodation.',
        areaServed: { '@type': 'City', name: 'London' },
        serviceType: 'Inbound Tourism Services',
        hasOfferCatalog: {
          '@type': 'OfferCatalog',
          name: 'Visit London Services',
          itemListElement: [
            { '@type': 'Offer', name: 'Budget Hotels London', description: 'Affordable Muslim-friendly hotels in central London' },
            { '@type': 'Offer', name: 'Airport Transfers', description: 'Private transfers from Heathrow, Gatwick, Stansted, and Luton airports' },
            { '@type': 'Offer', name: 'Business Travel Services', description: 'Corporate travel management and business accommodation in London' },
          ],
        },
      },
    ];

    schemas.forEach((schema) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
      scripts.push(script);
    });

    document.title = 'Visit London Services | Hotels, Airport Transfers & Business Travel | Alwaz Travels';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', 'Planning to visit London? Alwaz Travels offers budget hotels, airport transfers, business travel services, and Muslim-friendly accommodation in London for international visitors.');

    return () => {
      scripts.forEach((s) => s.parentNode?.removeChild(s));
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      <ServicesGrid />
      <BudgetHotels />
      <AirportTransfers />
      <BusinessServices />
      <WhyChooseUs />
      <CTASection />
      <Footer />
    </div>
  );
}
